import { env } from '../config/env';

/**
 * Resolves an image path to a fully qualified URL.
 * If the path is relative and points to mock images, it preserves the relative path.
 * Otherwise, it prepends the backend API origin.
 */
export function getImageUrl(path?: string | null): string {
  if (!path) return '';
  
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('blob:') ||
    path.startsWith('data:')
  ) {
    return path;
  }

  // Preserve local mock images
  if (path.startsWith('/images/')) {
    return path;
  }

  try {
    const apiOrigin = new URL(env.apiBaseUrl).origin;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${apiOrigin}${cleanPath}`;
  } catch {
    return path;
  }
}
